import { cn } from "@app/lib/utils";
import { keyFigures, type KeyFigureIcon } from "@modules/investor-relations/data";
import { trans } from "@mongez/localization";
import { Award, BarChart3, Factory, Globe, Layers } from "lucide-react";
import type { LucideIcon } from "lucide-react";

const icons: Record<KeyFigureIcon, LucideIcon> = {
  sectors: Layers,
  countries: Globe,
  years: Award,
  facilities: Factory,
  revenue: BarChart3,
};

/**
 * Key Figures — Section 03. Sits at the foot of the hero band, inside the
 * hero's dark background.
 */
export function HeroKeyFigures() {
  return (
    <div className="container relative z-10 mt-10 sm:mt-14">
      <ul
        aria-label={trans("heroKeyFigures.ariaLabel")}
        className="grid grid-cols-2 gap-y-8 rounded-2xl border border-white/15 bg-white/[0.04] px-2 py-8 sm:grid-cols-3 sm:gap-y-10 sm:px-4 lg:grid-cols-5 lg:gap-y-0 lg:px-6 lg:py-10"
      >
        {keyFigures.map(({ value, suffix, label, icon }, index) => {
          const Icon = icons[icon];

          return (
            <li
              key={label}
              className={cn(
                "flex flex-col items-center gap-2.5 px-3 text-center max-sm:last:col-span-2",
                index > 0 && "lg:border-s lg:border-white/15",
              )}
            >
              <span className="flex items-center gap-3">
                <Icon
                  className="size-7 shrink-0 text-bright-orange sm:size-8"
                  strokeWidth={1.5}
                  aria-hidden
                />
                <span className="text-3xl font-bold leading-none text-white sm:text-[2.5rem]">
                  {value}
                  {suffix && (
                    <span className="text-xl sm:text-2xl">{trans(suffix)}</span>
                  )}
                </span>
              </span>
              <span className="text-[0.625rem] font-semibold uppercase leading-snug tracking-[0.12em] text-white/70 sm:text-xs">
                {trans(label)}
              </span>
            </li>
          );
        })}
      </ul>
    </div>
  );
}
